import React from 'react';
import './Disclaimer.css';

function Disclaimer({ children, className = '' }) {
  return (
    <div className={`shared-disclaimer ${className}`.trim()} role="note">
      {children}
    </div>
  );
}

export default Disclaimer;
